import {SET_TOP_DATA} from './actionTypes';

export const setTopData = (data) => (
	{
		type: SET_TOP_DATA,
		payload: data
	}
);
